import { render, staticRenderFns } from "./AuthorizeTest.vue?vue&type=template&id=65f9f52c&scoped=true&"
import script from "./AuthorizeTest.vue?vue&type=script&lang=js&"
export * from "./AuthorizeTest.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizeTest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AuthorizeTest.vue?vue&type=style&index=1&id=65f9f52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f9f52c",
  null
  
)

export default component.exports